module.exports = __webpack_public_path__ + "static/media/GA-2100FF-8AER_OR09_bandview.e0d93c48.jpg";